import React from 'react'
import { LoadingText } from '@grammarly/assistant-ui-kit'

import { ToolType } from '../types'
import { useTool } from '../tool-context'
import { minimumLoadingTime } from '../constants'

const toolTypeToSteps = (toolType: ToolType) => {
  switch (toolType) {
    case 'aiDetector':
    case 'plagiarismChecker':
      return [
        'Analyzing your text',
        'Reviewing writing styles',
        'Checking language patterns',
        'Evaluating text variety',
        'Calculating confidence metrics',
        'Generating your report',
      ]
    case 'paraphraser':
    case 'humanizer':
    case 'goTemplatesGeneric':
    default:
      return ['Analyzing your text', 'Reviewing writing styles', 'Checking language patterns', 'Transforming your text']
  }
}

export const ToolLoading: React.FC = () => {
  const { toolType } = useTool()

  return (
    <LoadingText
      steps={toolTypeToSteps(toolType)}
      simulateStepLoading={true}
      simulatedLoadingTime={minimumLoadingTime}
    />
  )
}
